import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Alert, Button, Card, Col, Container, Form, Row, Spinner } from 'react-bootstrap';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const getForgotPasswordErrorMessage = (error) => {
  const detail = error.response?.data?.detail;

  if (typeof detail === 'string') {
    return detail;
  }

  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map((item) => item.msg).filter(Boolean).join(' ') || 'Please enter a valid email address.';
  }

  return error.response?.data?.message || 'Unable to send password reset email. Please try again.';
};

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/v1/auth/forgot-password`, {
        email,
      });

      setMessage(response.data?.message || 'If an account with that email exists, a password reset link has been sent.');
    } catch (err) {
      setError(getForgotPasswordErrorMessage(err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100">
        <Col md={6} lg={4} className="mx-auto">
          <Card className="shadow-sm">
            <Card.Body>
              <div className="text-center mb-4">
                <img
                  alt="AGRISMART logo"
                  src="/android-chrome-192x192.png"
                  width="60"
                  height="60"
                />
                <h2 className="mt-2">Forgot password</h2>
              </div>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="forgot-password-email" className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                    placeholder="Enter email"
                  />
                </Form.Group>

                {error && <Alert variant="danger">{error}</Alert>}
                {message && <Alert variant="success">{message}</Alert>}

                <Button variant="primary" type="submit" className="w-100" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Sending reset link
                    </>
                  ) : (
                    'Send reset link'
                  )}
                </Button>

                <div className="text-center mt-3">
                  <Button as={Link} to="/login" variant="link" className="p-0">
                    Back to login
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPasswordPage;
